import React from 'react'
import { IntrigrationSec } from './intrigrationSec'

export const IntrigrationBankVerification = () => {
  return (
    <>
    <IntrigrationSec /> 
    </>
  )
}
